/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddFishGroupProperty} from '../bioplanModels';
// @ts-ignore
import type {EditFishGroupProperty} from '../bioplanModels';
// @ts-ignore
import type {FishGroupProperty} from '../bioplanModels';
/**
 * PlanningFishGroupPropertiesApi - axios parameter creator
 * @export
 */
export const PlanningFishGroupPropertiesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete fish_group_property by its identifier
     * @param {string} fishPropertyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesFishPropertyIdDelete: async (
      fishPropertyId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishPropertyId' is not null or undefined
      assertParamExists('fishGroupPropertiesFishPropertyIdDelete', 'fishPropertyId', fishPropertyId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishGroupPropertiesFishPropertyIdDelete', 'planId', planId);
      const localVarPath = `/fishGroupProperties/{fishPropertyId}`.replace(
        `{${'fishPropertyId'}}`,
        encodeURIComponent(String(fishPropertyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get fish_group_property by its identifier
     * @param {string} fishPropertyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesFishPropertyIdGet: async (
      fishPropertyId: string,
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishPropertyId' is not null or undefined
      assertParamExists('fishGroupPropertiesFishPropertyIdGet', 'fishPropertyId', fishPropertyId);
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishGroupPropertiesFishPropertyIdGet', 'planId', planId);
      const localVarPath = `/fishGroupProperties/{fishPropertyId}`.replace(
        `{${'fishPropertyId'}}`,
        encodeURIComponent(String(fishPropertyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update fish_group_property
     * @param {string} fishPropertyId
     * @param {EditFishGroupProperty} editFishGroupProperty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesFishPropertyIdPut: async (
      fishPropertyId: string,
      editFishGroupProperty: EditFishGroupProperty,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'fishPropertyId' is not null or undefined
      assertParamExists('fishGroupPropertiesFishPropertyIdPut', 'fishPropertyId', fishPropertyId);
      // verify required parameter 'editFishGroupProperty' is not null or undefined
      assertParamExists('fishGroupPropertiesFishPropertyIdPut', 'editFishGroupProperty', editFishGroupProperty);
      const localVarPath = `/fishGroupProperties/{fishPropertyId}`.replace(
        `{${'fishPropertyId'}}`,
        encodeURIComponent(String(fishPropertyId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editFishGroupProperty, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all fish_properties for the provided planId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('fishGroupPropertiesGet', 'planId', planId);
      const localVarPath = `/fishGroupProperties/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create fish_group_property
     * @param {AddFishGroupProperty} addFishGroupProperty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesPost: async (
      addFishGroupProperty: AddFishGroupProperty,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addFishGroupProperty' is not null or undefined
      assertParamExists('fishGroupPropertiesPost', 'addFishGroupProperty', addFishGroupProperty);
      const localVarPath = `/fishGroupProperties/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addFishGroupProperty, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningFishGroupPropertiesApi - functional programming interface
 * @export
 */
export const PlanningFishGroupPropertiesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningFishGroupPropertiesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete fish_group_property by its identifier
     * @param {string} fishPropertyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupPropertiesFishPropertyIdDelete(
      fishPropertyId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupPropertiesFishPropertyIdDelete(
        fishPropertyId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupPropertiesApi.fishGroupPropertiesFishPropertyIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get fish_group_property by its identifier
     * @param {string} fishPropertyId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupPropertiesFishPropertyIdGet(
      fishPropertyId: string,
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishGroupProperty>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupPropertiesFishPropertyIdGet(
        fishPropertyId,
        planId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupPropertiesApi.fishGroupPropertiesFishPropertyIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update fish_group_property
     * @param {string} fishPropertyId
     * @param {EditFishGroupProperty} editFishGroupProperty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupPropertiesFishPropertyIdPut(
      fishPropertyId: string,
      editFishGroupProperty: EditFishGroupProperty,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishGroupProperty>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupPropertiesFishPropertyIdPut(
        fishPropertyId,
        editFishGroupProperty,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupPropertiesApi.fishGroupPropertiesFishPropertyIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all fish_properties for the provided planId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupPropertiesGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FishGroupProperty>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupPropertiesGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupPropertiesApi.fishGroupPropertiesGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create fish_group_property
     * @param {AddFishGroupProperty} addFishGroupProperty
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async fishGroupPropertiesPost(
      addFishGroupProperty: AddFishGroupProperty,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FishGroupProperty>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.fishGroupPropertiesPost(addFishGroupProperty, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningFishGroupPropertiesApi.fishGroupPropertiesPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningFishGroupPropertiesApi - factory interface
 * @export
 */
export const PlanningFishGroupPropertiesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningFishGroupPropertiesApiFp(configuration);
  return {
    /**
     *
     * @summary Delete fish_group_property by its identifier
     * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesFishPropertyIdDelete(
      requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .fishGroupPropertiesFishPropertyIdDelete(requestParameters.fishPropertyId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get fish_group_property by its identifier
     * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesFishPropertyIdGet(
      requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishGroupProperty> {
      return localVarFp
        .fishGroupPropertiesFishPropertyIdGet(requestParameters.fishPropertyId, requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update fish_group_property
     * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesFishPropertyIdPut(
      requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishGroupProperty> {
      return localVarFp
        .fishGroupPropertiesFishPropertyIdPut(
          requestParameters.fishPropertyId,
          requestParameters.editFishGroupProperty,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all fish_properties for the provided planId
     * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesGet(
      requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<FishGroupProperty>> {
      return localVarFp
        .fishGroupPropertiesGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create fish_group_property
     * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    fishGroupPropertiesPost(
      requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FishGroupProperty> {
      return localVarFp
        .fishGroupPropertiesPost(requestParameters.addFishGroupProperty, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for fishGroupPropertiesFishPropertyIdDelete operation in PlanningFishGroupPropertiesApi.
 * @export
 * @interface PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDeleteRequest
 */
export interface PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDelete
   */
  readonly fishPropertyId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for fishGroupPropertiesFishPropertyIdGet operation in PlanningFishGroupPropertiesApi.
 * @export
 * @interface PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGetRequest
 */
export interface PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGet
   */
  readonly fishPropertyId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGet
   */
  readonly planId: string;
}

/**
 * Request parameters for fishGroupPropertiesFishPropertyIdPut operation in PlanningFishGroupPropertiesApi.
 * @export
 * @interface PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPutRequest
 */
export interface PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPut
   */
  readonly fishPropertyId: string;

  /**
   *
   * @type {EditFishGroupProperty}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPut
   */
  readonly editFishGroupProperty: EditFishGroupProperty;
}

/**
 * Request parameters for fishGroupPropertiesGet operation in PlanningFishGroupPropertiesApi.
 * @export
 * @interface PlanningFishGroupPropertiesApiFishGroupPropertiesGetRequest
 */
export interface PlanningFishGroupPropertiesApiFishGroupPropertiesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesGet
   */
  readonly planId: string;
}

/**
 * Request parameters for fishGroupPropertiesPost operation in PlanningFishGroupPropertiesApi.
 * @export
 * @interface PlanningFishGroupPropertiesApiFishGroupPropertiesPostRequest
 */
export interface PlanningFishGroupPropertiesApiFishGroupPropertiesPostRequest {
  /**
   *
   * @type {AddFishGroupProperty}
   * @memberof PlanningFishGroupPropertiesApiFishGroupPropertiesPost
   */
  readonly addFishGroupProperty: AddFishGroupProperty;
}

/**
 * PlanningFishGroupPropertiesApi - object-oriented interface
 * @export
 * @class PlanningFishGroupPropertiesApi
 * @extends {BaseAPI}
 */
export class PlanningFishGroupPropertiesApi extends BaseAPI {
  /**
   *
   * @summary Delete fish_group_property by its identifier
   * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupPropertiesApi
   */
  public fishGroupPropertiesFishPropertyIdDelete(
    requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupPropertiesApiFp(this.configuration)
      .fishGroupPropertiesFishPropertyIdDelete(requestParameters.fishPropertyId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get fish_group_property by its identifier
   * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupPropertiesApi
   */
  public fishGroupPropertiesFishPropertyIdGet(
    requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupPropertiesApiFp(this.configuration)
      .fishGroupPropertiesFishPropertyIdGet(requestParameters.fishPropertyId, requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update fish_group_property
   * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupPropertiesApi
   */
  public fishGroupPropertiesFishPropertyIdPut(
    requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesFishPropertyIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupPropertiesApiFp(this.configuration)
      .fishGroupPropertiesFishPropertyIdPut(
        requestParameters.fishPropertyId,
        requestParameters.editFishGroupProperty,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all fish_properties for the provided planId
   * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupPropertiesApi
   */
  public fishGroupPropertiesGet(
    requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupPropertiesApiFp(this.configuration)
      .fishGroupPropertiesGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create fish_group_property
   * @param {PlanningFishGroupPropertiesApiFishGroupPropertiesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningFishGroupPropertiesApi
   */
  public fishGroupPropertiesPost(
    requestParameters: PlanningFishGroupPropertiesApiFishGroupPropertiesPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningFishGroupPropertiesApiFp(this.configuration)
      .fishGroupPropertiesPost(requestParameters.addFishGroupProperty, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
